import type { Theme } from "@/types";
import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export const getThemes = async (): Promise<ServiceResponse<Theme[]>> => {
  const response = await privateAPI.get<ServiceResponse<Theme[]>>("/themes");
  return response.data;
};
